module.exports = __webpack_public_path__ + "static/media/rush_bookmark_seeds_2x.6afe2bf2.jpg";